export default function PageShell({ title, subtitle, children }) {
  return (
    <main className="w-full">
      <section className="w-full border-b border-white/[0.06] bg-surface pt-12">
        <div className="container mx-auto max-w-6xl px-4 pb-10 md:px-6">
          <div className="flex flex-col items-start justify-between gap-6 sm:flex-row">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand">Aimrane Digital</p>
              <h1 className="mt-3 font-display text-3xl font-bold text-white md:text-4xl">{title}</h1>
              {subtitle ? (
                <p className="mt-3 max-w-2xl text-zinc-500">{subtitle}</p>
              ) : null}
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-surface py-12">
        <div className="container mx-auto max-w-6xl px-4 md:px-6">{children}</div>
      </section>
    </main>
  );
}

